export default __webpack_public_path__ + "static/media/hrm-2.0ad466c6.png";